<template>
    <form role="form">
        <div class="container-fluid shadow">
            <div class="row">
                         <div class="row">
                            <div style="padding-left: 20px;" class="col-md text-left">
                                <label style="border-bottom: 1px solid lightgray; width: 100%;" class="text-left">{{shopCart2AltOptions.ragioneSocialeLbl}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div style="padding-left: 27px;" class="col-sm-6 text-left">
                                <span class="align-middle" >{{ragioneSocialeValue}}</span>
                            </div>
                        </div>
                         <div class="row">
                            <div class="col-md ">
                                &nbsp;
                            </div>
                        </div>

                        <div class="row">
                            <div style="padding-left: 20px;" class="col-md-5 text-left">
                                <label class="text-left">{{shopCart2AltOptions.richiedenteLbl}}</label>
                            </div>
                            <div class="col-md-7 text-left">
                                <label class="text-left">{{shopCart2AltOptions.altroRichiedenteLbl}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                            </div>
                            <div class="col-md-7">
                                <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.nomeCognomeLbl}}</span>
                                    </div>
                                    <input-w v-model="ragioneSocialeValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input  v-model="nomeCognomeRichiedenteValue" type="text" id="nomeCognomeRichiedenteId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.nomeCognomeLbl}}</span>
                                    </div>
                                     <input-w v-model="ragioneSocialeValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input  v-model="nomeCognomeAltroRicValue" type="text" id="nomeCognomeAltroRicId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div class="col-md-2" style="padding-left: 1px;">
                                         <button @click.prevent="altroRichiedenteClick" style="width: 130px;">{{shopCart2AltOptions.altroRichiedenteLbl}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.mailLbl}}</span>
                                    </div>
                                    <input-w v-model="mailRichiedenteValue"  :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="mailRichiedenteValue" id="mailRichiedenteId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.mailLbl}}</span>
                                    </div>
                                    <input-w v-model="mailAltroRicValue"  :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="mailAltroRicValue" id="mailAltroRicID" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div v-if="altroRichSelected" class="col-md-2" style="padding-left: 1px;">
                                        <button @click.prevent="annullaAltroRichiedente" style="width: 130px;">{{shopCart2AltOptions.annullaAltroRichiedenteBtnLbl}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.faxLbl}}</span>
                                    </div>
                                    <input-w v-model="faxRichiedenteValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="faxRichiedenteValue" id="faxRichiedenteId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.faxLbl}}</span>
                                    </div>
                                    <input-w v-model="faxAltroRicValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text"  v-model="faxAltroRicValue" id="faxAltroRicId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div class="col-md-2">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.telLbl}}</span>
                                    </div>
                                    <input-w v-model="telRichiedenteValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="telRichiedenteValue" id="telRichiedenteId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                               <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.telLbl}}</span>
                                    </div>
                                    <input-w v-model="telAltroRicValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="telAltroRicValue" id="telAltroRicId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div class="col-md-2">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                         <div class="row">
                            <div style="padding-left: 20px;" class="col-md-5 text-left">
                                <label class="text-left">{{shopCart2AltOptions.indirizzoConsPredLbl}}</label>
                            </div>
                            <div class="col-md-7 text-left">
                                <label class="text-left">{{shopCart2AltOptions.altroIndirizzoConsLbl}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                            </div>
                            <div class="col-md-7">
                                <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                            </div>
                        </div>



                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.indirizzoConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="indirizzoConsegnaValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="indirizzoConsegnaValue" id="indirizzoConsegnaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.indirizzoConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="indirizzoAltroValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="indirizzoAltroValue" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div class="col-md-2" style="padding-left: 1px;">
                                        <button @click.prevent="altroIndirizzoClick" style="width: 130px;">{{shopCart2AltOptions.altroIndirizzoBtnLbl}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.capConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="capConsegnaValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="capConsegnaValue" id="capConsegnaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.capConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="capAltroValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="capAltroValue" id="capAltroId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div v-if="altroIndiSelected" class="col-md-2" style="padding-left: 1px;">
                                        <button @click.prevent="annullaAltroIndirizzo" style="width: 130px;">{{shopCart2AltOptions.annullaAltroIndirizzoBtnLbl}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                       <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.localitaConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="localitaConsegnaValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="localitaConsegnaValue" id="localitaConsegnaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.localitaConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="localitaAltroValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="localitaAltroValue" id="localitaAltroId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div class="col-md-2">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.provinciaConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="provinciaConsegnaValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="provinciaConsegnaValue" id="provinciaConsegnaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.provinciaConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="provinciaAltroValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="provinciaAltroValue" id="provinciaAltroId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div class="col-md-2">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                   
                        <div class="row">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <div class="col-sm-6">
                                        <span class="align-middle">{{shopCart2AltOptions.nazioneConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="nazioneConsegnaValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="nazioneConsegnaValue" id="nazioneConsegnaId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.regioneAltroLbl}}</span>
                                    </div>
                                    <input-w v-model="regioneAltroValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="regioneAltroValue" id="regioneAltroId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div class="col-md-2">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                        
    
                        <div class="row">
                            <div class="col-md-5">
                                &nbsp;
                            </div>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <div class="col-sm-4">
                                        <span class="align-middle">{{shopCart2AltOptions.nazioneConsegnaLbl}}</span>
                                    </div>
                                    <input-w v-model="nazioneAltroValue" :configs="shopCart2AltOptions">
                                        <div class="col-sm-6"><input type="text" v-model="nazioneAltroValue" id="nazioneAltroId" class="form-control form-control-cust" /></div>
                                    </input-w>
                                    <div class="col-md-2">&nbsp;</div>
                                </div>
                            </div>
                        </div>    

                        <div class="row">
                            <div class="col-md-5">&nbsp;</div>
                            <div class="col-md-7">&nbsp;</div>
                        </div>

                        <div class="row">
                            <div class="col-md-7">
                                <div class="controls col-sm-3">
                                    <button @click.prevent="previousClick" class="btn btn-primary-default" style="width: 130px">{{shopCart2AltOptions.indietroBtnLbl}}</button>
                                </div>
                                <div class="col-md-1"></div>
                                <div class="controls col-sm-3">
                                    <button @click.prevent="forwardClick" class="btn btn-primary-default" style="width: 130px">{{shopCart2AltOptions.avantiBtnLbl}}</button>
                                </div>
                                <div class="col-md-1"></div>
                                <cfg cid="shopCart.nuovoOrdineBtn" tag='div'>
                                <div class="controls col-sm-3">
                                    <button @click.prevent="cleanShopCartClick"  class="btn btn-danger" style="width: 140px">{{$Jed.firstUpperTranslate('new order')}}</button>
                                </div>
                                </cfg>
                            </div>
                            <div class="col-md-3"></div>
                            <div class="col-md-2"></div>
                        </div>
                        <div class="row">
                            <div class="col-md">&nbsp;
                            </div>
                        </div>                               
                    </div>
                </div>
        <span>
        </span>
    </form>

</template>

<script>

var w;
$(document).ready(function() {
  w =  $(window).width();
});



import Datepicker from "vuejs-datepicker";
import Grid from '../../dynamic/jqwGridWrapper/jqwGridWrapper.vue'
import InputW from '../../dynamic/inputWrapper/inputWrapper.vue'
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'
import DynTableWrapper from "../../dynamic/DynTableWrapper.vue";
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import table_resize_mixin from "../../../mixins/table_resize_mixin.js";
import SingleModal from "../../dynamic/modalWrapper/SingleModal.vue";
import { eventBus } from "../../../eventbus";
import {Checkbox} from 'vue-checkbox-radio';
import Cfg from "../../dynamic/ConfigurableComponent.vue";

export default {
    mixins: [FormMixin],
    components: {
        Grid,
        InputW,
        DynTableWrapper,
        Datepicker,
        vSelect,
        SingleModal,
        Checkbox,
        Cfg
    },
    data: function () {
        var vm = this;
        return {
            shopCart2AltOptions: {
                ragioneSocialeLbl: vm.$Jed.firstUpperTranslate('business name'),
                richiedenteLbl: vm.$Jed.firstUpperTranslate('requester (current user)'),
                altroRichiedenteLbl: vm.$Jed.firstUpperTranslate('other requester'),
                nomeCognomeLbl: vm.$Jed.firstUpperTranslate('name')+" "+vm.$Jed.firstUpperTranslate('surname'),
                mailLbl: vm.$Jed.firstUpperTranslate('email'),
                faxLbl: vm.$Jed.firstUpperTranslate('fax'),
                telLbl: vm.$Jed.firstUpperTranslate('phone'),
                indirizzoConsPredLbl: vm.$Jed.firstUpperTranslate('predefined delivery address'),
                altroIndirizzoConsLbl: vm.$Jed.firstUpperTranslate('other delivery address'),      
                indirizzoConsegnaLbl: vm.$Jed.firstUpperTranslate('address'),
                capConsegnaLbl: vm.$Jed.firstUpperTranslate('CAP'),
                localitaConsegnaLbl: vm.$Jed.firstUpperTranslate('Localita'),
                provinciaConsegnaLbl: vm.$Jed.firstUpperTranslate('province'),
                nazioneConsegnaLbl: vm.$Jed.firstUpperTranslate('country'),
                regioneAltroLbl: vm.$Jed.firstUpperTranslate('Zona Cliente'),
                indietroBtnLbl: vm.$Jed.firstUpperTranslate('back'),
                avantiBtnLbl: vm.$Jed.firstUpperTranslate('continue'),
                altroIndirizzoBtnLbl: vm.$Jed.firstUpperTranslate('other address'),
                annullaAltroRichiedenteBtnLbl: vm.$Jed.firstUpperTranslate('cancel'),
                annullaAltroIndirizzoBtnLbl: vm.$Jed.firstUpperTranslate('cancel')
            },
            //Richiedente (utente corrente)
            ragioneSocialeValue: vm.$root.shopCartData.anagraficaCliente.ragioneSociale,
            nomeCognomeRichiedenteValue: '',
            mailRichiedenteValue: '',
            faxRichiedenteValue: '',
            telRichiedenteValue: '',
            //Altro richiedente
            nomeCognomeAltroRicValue: vm.$root.shopCartData.altrorichiedente.nomecognome,
            mailAltroRicValue: vm.$root.shopCartData.altrorichiedente.mail,
            faxAltroRicValue: vm.$root.shopCartData.altrorichiedente.fax,
            telAltroRicValue: vm.$root.shopCartData.altrorichiedente.telefono,
            idAltroRic: vm.$root.shopCartData.altrorichiedente.id,
            //Indirizzo consegna predefinito
            indirizzoConsegnaValue: "",
            capConsegnaValue: "",
            localitaConsegnaValue: "",
            provinciaConsegnaValue: "",
            nazioneConsegnaValue: "",
            //Altro indirizzo di consegna
            indirizzoAltroValue: vm.$root.shopCartData.altroindirizzoconsegna.indirizzo,
            capAltroValue: vm.$root.shopCartData.altroindirizzoconsegna.cap,
            localitaAltroValue: vm.$root.shopCartData.altroindirizzoconsegna.localita,
            provinciaAltroValue: vm.$root.shopCartData.altroindirizzoconsegna.provincia,
            regioneAltroValue: vm.$root.shopCartData.altroindirizzoconsegna.regione,
            nazioneAltroValue: vm.$root.shopCartData.altroindirizzoconsegna.nazione,
            idAltroIndirizzo: vm.$root.shopCartData.altroindirizzoconsegna.idIndirizzo,
            
            showCancelOtherAddr: false,
            showCancelOtherReq: false,
            altroRichSelected: vm.$root.shopCartData.altrorichiedente.mail ? true : false,
            altroIndiSelected: vm.$root.shopCartData.altroindirizzoconsegna.indirizzo ? true : false
        }
    },
    created: function(){
        var vm = this;
        eventBus.$on("gotChanges",()=>{
            var reg_orders = vm.$root.dbRegistry.getCollection('orders'),
                reg_addresses = vm.$root.dbRegistry.getCollection('addresses'),
                idC = vm.$root.token.idCliente,
                order = reg_orders.find({'$loki': vm.$root.shopCartData.$loki}); //uso $loki perchè questo serve per aggiornare le schermate quando ho inserito un prodotto in carrello e ancora ci sono gli id provvisori (negativi) per ordine e righeordine
            if(order && order[0]){
                vm.$root.shopCartData.id = order[0].id; //imposto il nuovo id per la struttura che rappresenta il carrello (cioè ShopCartData) così posso usare questa proprietà per recuperare il record dall'idb quando serve
            }
            vm.updateData()
            vm.LoadCollections()
            vm.loadCollectionAddress()
        })
    },
    mounted: function() {
        var vm = this;

        //i valori per i campi del richiedente (utente corrente) e dell'indirizzo di consegna predefinito li prendo sempre freschi 
        var reg_users = this.$root.dbRegistry.getCollection('users');
        var curr_user = reg_users.find({
            'id': Number(this.$Configs.idUtente),
            'clientId': this.$Configs.idCliente
        })
        if(curr_user.length>0){
            vm.nomeCognomeRichiedenteValue = curr_user[0].userFullname
            vm.mailRichiedenteValue = curr_user[0].email
            vm.faxRichiedenteValue = curr_user[0].fax
            vm.telRichiedenteValue = curr_user[0].phone
        }

        var reg_addresses = this.$root.dbRegistry.getCollection('addresses');
        var addr_of_cli = reg_addresses.find({
            'cid': this.$Configs.idCliente,
            'dea': true //indirizzo di consegna
        })
        if(addr_of_cli.length>0){
            vm.indirizzoConsegnaValue = addr_of_cli[0].add
            vm.capConsegnaValue = addr_of_cli[0].cap
            vm.localitaConsegnaValue = addr_of_cli[0].loc
            vm.provinciaConsegnaValue = addr_of_cli[0].pro
            vm.nazioneConsegnaValue = addr_of_cli[0].nat
        }
    }, 
    methods: {
        updateData(data) {
            if(data && data.userFullname){
                //aggiorno i campi in ShopCartData
                this.$root.shopCartData.altrorichiedente.nomecognome = data.userFullname
                this.$root.shopCartData.altrorichiedente.mail = data.email
                this.$root.shopCartData.altrorichiedente.fax = data.fax
                this.$root.shopCartData.altrorichiedente.telefono = data.phone
                this.$root.shopCartData.altrorichiedente.id = data.id
                //aggiorno i campi dell'interfaccia
                this.nomeCognomeAltroRicValue = data.userFullname
                this.mailAltroRicValue = data.email
                this.faxAltroRicValue = data.fax
                this.telAltroRicValue = data.phone
                this.idAltroRic = data.id
                this.altroRichSelected = true;
            }
            if(data && data.add){
                this.$root.shopCartData.altroindirizzoconsegna.indirizzo = data.add
                this.$root.shopCartData.altroindirizzoconsegna.localita = data.loc
                this.$root.shopCartData.altroindirizzoconsegna.cap = data.cap
                this.$root.shopCartData.altroindirizzoconsegna.nazione = data.nat
                this.$root.shopCartData.altroindirizzoconsegna.provincia = data.pro
                this.$root.shopCartData.altroindirizzoconsegna.regione = data.reg
                this.$root.shopCartData.altroindirizzoconsegna.idIndirizzo = data.id
                this.$root.shopCartData.altroindirizzoconsegna.sigPro = data.sip
                this.indirizzoAltroValue = data.add
                this.capAltroValue = data.cap
                this.localitaAltroValue = data.loc
                this.provinciaAltroValue = data.pro
                this.regioneAltroValue = data.reg
                this.nazioneAltroValue = data.nat
                this.idAltroIndirizzo = data.id
                this.altroIndiSelected = true;
            }
        },
        previousClick () {
            this.$emit('changeComponentEvent',1, this.getData());
        },
        forwardClick () {
            var data = {};
            var vm = this;
            if(!this.mailAltroRicValue || this.mailAltroRicValue=="" || !this.indirizzoAltroValue || this.indirizzoAltroValue==""){
                var field_to_proceed = ''
                if(!this.mailAltroRicValue || this.mailAltroRicValue==""){
                    field_to_proceed = vm.$Jed.firstUpperTranslate("other requester")
                }
                if(!this.indirizzoAltroValue || this.indirizzoAltroValue==""){
                    field_to_proceed = vm.$Jed.firstUpperTranslate("other address")
                }
                if((!this.mailAltroRicValue || this.mailAltroRicValue=="") && (!this.indirizzoAltroValue || this.indirizzoAltroValue=="")){
                    field_to_proceed = vm.$Jed.firstUpperTranslate("other requester")+", "+vm.$Jed.firstUpperTranslate("other address")
                }
                
                var ok = function(){
                        this.close();
                        vm.$emit('changeComponentEvent',3, vm.getData());    
                    },
                    no = function(){
                        this.close();
                    },
                    e = {
                        message: vm.$Jed.firstUpperTranslate("you didn't choose")+" "+field_to_proceed+"<br>"+vm.$Jed.firstUpperTranslate("do you want to proceed?"),
                        ok: ok,
                        no: no
                    }
                eventBus.$emit("confirm", e) 
            }else{
                vm.$emit('changeComponentEvent',3, vm.getData());    
            }
        },
        cleanShopCartClick () {
            this.$emit('onCleanShopCartEvent', '');      
        },
        altroRichiedenteClick() {
            var users = this.$root.dbRegistry.getCollection('users').data
            this.$emit('onOpenOtherRequesterEvent', users);
        },
        altroIndirizzoClick () {
            var addresses = this.$root.dbRegistry.getCollection('addresses').data
            this.$emit('onOpenOtherAddressEvent', addresses);      
        },
        annullaAltroRichiedente(){
            this.$root.shopCartData.altrorichiedente.nomecognome = ""
            this.$root.shopCartData.altrorichiedente.mail = ""
            this.$root.shopCartData.altrorichiedente.fax = ""
            this.$root.shopCartData.altrorichiedente.telefono = ""
            this.$root.shopCartData.altrorichiedente.id = ""
            this.nomeCognomeAltroRicValue = ""
            this.mailAltroRicValue = ""
            this.faxAltroRicValue = ""
            this.telAltroRicValue = ""
            this.idAltroRic = ""
        },
        annullaAltroIndirizzo(){
            this.$root.shopCartData.altroindirizzoconsegna.indirizzo = ""
            this.$root.shopCartData.altroindirizzoconsegna.localita = ""
            this.$root.shopCartData.altroindirizzoconsegna.cap = ""
            this.$root.shopCartData.altroindirizzoconsegna.nazione = ""
            this.$root.shopCartData.altroindirizzoconsegna.provincia = ""
            this.$root.shopCartData.altroindirizzoconsegna.regione = ""
            this.$root.shopCartData.altroindirizzoconsegna.idIndirizzo = ""
            this.indirizzoAltroValue = ""
            this.capAltroValue = ""
            this.localitaAltroValue = ""
            this.provinciaAltroValue = ""
            this.regioneAltroValue = ""
            this.nazioneAltroValue = ""
            this.idAltroIndirizzo = ""
        },
        changeStep: function(val) {  
            if (val != 2)          
                this.$emit('changeComponentEvent',val, this.getData())  ;  
        },
        getData() {
            //Aggiorno la struttura carrello e l'ordine con le informazioni su consegna e richiedente
            if(this.indirizzoAltroValue && this.indirizzoAltroValue != ""){
                this.$root.shopCartData.altroindirizzoconsegna.indirizzo = this.indirizzoAltroValue 
                this.$root.shopCartData.altroindirizzoconsegna.localita = this.localitaAltroValue 
                this.$root.shopCartData.altroindirizzoconsegna.cap = this.capAltroValue
                this.$root.shopCartData.altroindirizzoconsegna.nazione = this.nazioneAltroValue
                this.$root.shopCartData.altroindirizzoconsegna.provincia = this.provinciaAltroValue
                this.$root.shopCartData.altroindirizzoconsegna.regione = this.regioneAltroValue
                this.$root.shopCartData.altroindirizzoconsegna.idIndirizzo = this.idAltroIndirizzo
            }else{
                this.$root.shopCartData.consegna.indirizzo = this.indirizzoConsegnaValue 
                this.$root.shopCartData.consegna.localita = this.localitaConsegnaValue 
                this.$root.shopCartData.consegna.cap = this.capConsegnaValue
                this.$root.shopCartData.consegna.nazione = this.nazioneConsegnaValue
                this.$root.shopCartData.consegna.provincia = this.provinciaConsegnaValue
            }

            if(this.nomeCognomeAltroRicValue){
                this.$root.shopCartData.altrorichiedente.nomecognome = this.nomeCognomeAltroRicValue
                this.$root.shopCartData.altrorichiedente.mail = this.mailAltroRicValue 
                this.$root.shopCartData.altrorichiedente.fax = this.faxAltroRicValue
                this.$root.shopCartData.altrorichiedente.telefono = this.telAltroRicValue 
                this.$root.shopCartData.altrorichiedente.id = this.idAltroRic 
            }else{
                this.$root.shopCartData.richiedente.nomecognome = this.nomeCognomeRichiedenteValue
                this.$root.shopCartData.richiedente.mail = this.mailRichiedenteValue 
                this.$root.shopCartData.richiedente.fax = this.faxRichiedenteValue
                this.$root.shopCartData.richiedente.telefono = this.telRichiedenteValue 
                this.$root.shopCartData.richiedente.id = this.$root.token.idUtente
            }
             
            var vm = this,
                reg_orders = this.$root.dbRegistry.getCollection('orders'),
                order = reg_orders.find({'id': vm.$root.shopCartData.riferimento})[0],
                now = Date.now(),
                altroIndi = this.$root.shopCartData.altroindirizzoconsegna,
                altroRichi = this.$root.shopCartData.altrorichiedente,
                changed = false;
            
            if( order != null) {
                //confronto campi effettivamente cambiati per evitare update inutili 
                //potrei aver cambiato indirizzo, località, provincia, info richiedente, etc.
                
                var o_aid = altroIndi.idIndirizzo ? altroIndi.idIndirizzo : this.$root.shopCartData.consegna.idIndirizzo,
                    o_add = altroIndi.indirizzo ? altroIndi.indirizzo : this.$root.shopCartData.consegna.indirizzo,
                    o_cap = altroIndi.cap ? altroIndi.cap : this.$root.shopCartData.consegna.cap,
                    o_loc = altroIndi.localita ? altroIndi.localita : this.$root.shopCartData.consegna.localita,
                    o_reg = altroIndi.regione ? altroIndi.regione : this.$root.shopCartData.consegna.regione,
                    o_pro = altroIndi.provincia ? altroIndi.provincia : this.$root.shopCartData.consegna.provincia,
                    o_nat = altroIndi.nazione ? altroIndi.nazione : this.$root.shopCartData.consegna.nazione,

                    o_ufn = altroRichi.nomecognome ? altroRichi.nomecognome : this.$root.shopCartData.richiedente.nomecognome,
                    o_uem = altroRichi.mail ? altroRichi.mail : this.$root.shopCartData.richiedente.mail,
                    o_fax = altroRichi.fax ? altroRichi.fax : this.$root.shopCartData.richiedente.fax,
                    o_tel = altroRichi.telefono ? altroRichi.telefono : this.$root.shopCartData.richiedente.telefono,
                    o_uid = altroRichi.id ? altroRichi.id : this.$root.token.idUtente;

                if(order.aid != o_aid){order.aid = o_aid; changed = true;}
                if(order.add != o_add){order.add = o_add; changed = true;}
                if(order.cap != o_cap){order.cap = o_cap; changed = true;}
                if(order.loc != o_loc){order.loc = o_loc; changed = true;}
                if(order.reg != o_reg){order.reg = o_reg; changed = true;}
                if(order.pro != o_pro){order.pro = o_pro; changed = true;}
                if(order.nat != o_nat){order.nat = o_nat; changed = true;}
                
                if(order.ufn != o_ufn){order.ufn = o_ufn; changed = true;}
                if(order.uem != o_uem){order.uem = o_uem; changed = true;}
                if(order.fax != o_fax){order.fax = o_fax; changed = true;}
                if(order.tel != o_tel){order.tel = o_tel; changed = true;}
                if(order.uid != o_uid){order.uid = o_uid; changed = true;}

                if(changed){
                    order.mdt = now;
                    reg_orders.update(order);
                    console.log('ShopCart2Alternate: Aggiornato ordine con id:', order.id, order); 
                    //alla fine delle op sui loki di ordini e righeordine salvo il loki db e chiedo la sync
                    this.$root.dbRegistry.saveDatabase(function(err) {
                        if (err) {
                            console.log("saveDatabase - error : " + err);
                        } else {
                            if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                            console.log("ShopCart2Alternate: getData - saveDatabase - database aggiornato");
                            eventBus.$emit("cartFilled",vm.$root.shopCartData.prodotti.length);
                        }
                    });
                }
            }
            
            return this.$root.shopCartData;
        },
        resize(){}, //chiamata da ShopWrapper
        LoadCollections(){}, //chiamata da ShopWrapper
        loadCollectionAddress(){} //chiamata da ShopWrapper
    }
}
</script>

<style>

.colpad-align {
    padding-left: 15px;
    padding-right: 15px;

}

.form-control-cust  {
    height: 28px;
}

.v-select .dropdown-toggle {
    display: flex !important;
    flex-wrap: wrap;
}

.v-select input[type=search], .v-select input[type=search]:focus {
    flex-basis: 20px;
    flex-grow: 1;
    height: 28px;
    padding: 0 20px 0 10px;
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/ShopCart2Alternate.vue?20b8218d